






































import { Component, Prop, Vue } from "vue-property-decorator";
import VModal from "./VModal.vue";
import VContentLoading from "@/components/VContentLoading.vue";

@Component({
  components: {
    VModal,
    VContentLoading,
  },
})
export default class ConfirmModal extends Vue {
  @Prop({ default: false }) isLoading?: boolean;
  @Prop({ default: true }) closeOnConfirm?: boolean;
  @Prop({ default: "Do you confirm?" }) title?: string;
  @Prop({ default: "Loading..." }) contentLoadingText?: string;

  modal!: VModal;
  content = "";

  confirmed!: Function | null;
  canceled!: Function | null;

  mounted() {
    this.modal = this.$refs.modal as VModal;
  }

  get hasContent(): boolean {
    return this.$slots.default != null;
  }

  protected onCancel() {
    if (this.canceled) {
      this.canceled();
    }

    this.canceled = null;
    this.modal.hide();
  }

  protected onConfirm() {
    if (this.confirmed) {
      this.confirmed();
    }

    this.confirmed = null;
    if (this.closeOnConfirm) {
      this.modal.hide();
    }
  }

  protected onHidden() {
    if (this.canceled) {
      this.canceled();
    }
  }

  confirm(content: string | undefined = undefined): Promise<boolean> {
    this.modal.show();

    if (content) {
      this.content = content;
    }

    return new Promise((resolve) => {
      this.confirmed = () => {
        resolve(true);
      };

      this.canceled = () => {
        resolve(false);
      };
    });
  }

  hide() {
    this.modal.hide();
  }
}
